import(/* webpackMode: "eager" */ "__barrel_optimize__?names=App!=!/home/ec2-user/tamdaone/tamdamedia/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/home/ec2-user/tamdaone/tamdamedia/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/font/local/target.css?{\"path\":\"src/lib/get-font.ts\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-lato\",\"display\":\"swap\",\"src\":[{\"path\":\"../../public/fonts/Lato_Hairline.woff2\",\"weight\":\"100\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Thin.woff2\",\"weight\":\"200\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Semibold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Heavy.woff2\",\"weight\":\"800\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Black.woff2\",\"weight\":\"900\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Lato_Italic.woff2\",\"weight\":\"400\",\"style\":\"italic\"}]}],\"variableName\":\"lato\"}");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/font/google/target.css?{\"path\":\"src/lib/get-font.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/font/google/target.css?{\"path\":\"src/lib/get-font.ts\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-open_sans\",\"display\":\"swap\"}],\"variableName\":\"open_sans\"}");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/font/google/target.css?{\"path\":\"src/lib/get-font.ts\",\"import\":\"Josefin_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-josefin_sans\",\"display\":\"swap\"}],\"variableName\":\"josefin_sans\"}");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/font/google/target.css?{\"path\":\"src/lib/get-font.ts\",\"import\":\"Be_Vietnam_Pro\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-be_vietnam_pro\",\"display\":\"swap\",\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"be_vietnam_pro\"}");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/node_modules/next/font/google/target.css?{\"path\":\"src/lib/get-font.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-montserrat\",\"display\":\"swap\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow-left-swiper.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow-outside.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow-right-swiper.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/author.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/avatar-default.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/bg-latest-news.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/brand-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/close-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/edit-pencil.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/empty-img.jpg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/facebook-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/facebook-sidebar.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/homepage-gray-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/homepage-red-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/hot-news-gray-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/hot-news-red-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-calendar-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-cart.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-job-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-location-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-mail.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-phone.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-Quote.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-salary-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/image-empty.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/lang-tdg-vn.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/location.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-cs.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-en.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-tamdacms.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-tdg-mobile.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-tdg.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-vi.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logocms.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/menu-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/phone-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/play-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/search-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/sub-menu-logo.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/tamda-media-logo.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/tamda-wing.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/twitter_icon.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/video-gray-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/video-red-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/widgets-card.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/widgets-register-mail.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube-sidebar.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/tamdaone/tamdamedia/src/(admin)/modules/media/pages/Media.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/components/admin-bar/admin-bar.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/components/footer/footer-skeleton.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/components/gdpr-consent-banner.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/components/head-html-injector.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderViewClient"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/header-one/header-view.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrentDateDisplay"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/header/CurrentDateDisplay.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/header/header-skeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchFormFallback","default"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/header/search-form.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/components/progress-bar/progress-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TamdaMediaFooterViewClient"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/tamdamedia-footer-view.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TamdaMediaHeaderViewClient"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/tamdamedia-header-view.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TamdaOneFooterViewClient"] */ "/home/ec2-user/tamdaone/tamdamedia/src/components/tamdaone-footer-view.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nSync"] */ "/home/ec2-user/tamdaone/tamdamedia/src/languages/I18nSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["createPostClickHandler","handlePostClick","handlePostClickForLink","incrementPostViews"] */ "/home/ec2-user/tamdaone/tamdamedia/src/lib/post-navigation.ts");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/stores/use-domain-store.ts");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/styles/fonts/font-be-vietnam-pro.css");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/styles/fonts/font-lato.css");
